import React from 'react';
import { useSelector } from 'react-redux';
import { form } from '~/skills/getStatus';
import EAA_Btn from './EAA_Btn';
import { leftColor, rightColor } from './common';

const EAA_BottomBtn = ({
  data,
  mode,
  isCheck,
  allRight,
  canSend,
  onClose,
  goToCheck,
  goToEdit,
  add,
  edit,
  disGoBack = false,
}) => {
  const nowStatus = form(data);

  const role_type = useSelector(state => (state.data.AtyFunction || {}).role_type || '');
  const sign = useSelector(state => !!(state.data.AtyFunction || {}).sign);
  const sign_manage = sign && role_type.match('主管');
  const sign_admin = sign && role_type.match('管理者');
  const getCanBack = () => {
    if (sign && nowStatus.match('審查中')) {
      if (nowStatus.match('主管審查中') && sign_manage) return true;
      if (nowStatus.match('管理者審查中') && sign_admin) return true;
    }
    return false;
  };
  const canBack = getCanBack();
  const getReviewText = () => {
    if (nowStatus.match('尚未儲存') || nowStatus.match('已暫存')) {
      if (role_type.match('使用者')) return '送出審核';
    } else if (nowStatus.match('主管審查中')) {
      if (sign_manage) return '主管核准';
    } else if (nowStatus.match('管理者審查中')) {
      if (sign_admin) return '管理者核准';
    }
    return '';
  };
  const reviewText = getReviewText();
  const canReview = !!reviewText;

  const canSave = nowStatus.match('尚未儲存') || nowStatus.match('已暫存');

  const onAdd = () => {
    add({ form_status: '1', admin_status: '0' });
  };

  const onSave = () => {
    edit({ form_status: '1', admin_status: '0' });
  };

  const onBack = () => {
    edit({ form_status: '1', admin_status: '0' });
  };

  const onReview = () => {
    if (nowStatus.match('尚未儲存'))add({ form_status: '2', admin_status: '0' });
    if (nowStatus.match('已暫存'))edit({ form_status: '2', admin_status: '0' });
    else if (nowStatus.match('主管審查中'))edit({ form_status: '3', admin_status: '1' });
    else if (nowStatus.match('管理者審查中'))edit({ form_status: '3', admin_status: '2' });
  };

  return (
    <div style={{ display: 'flex', marginTop: 36, width: '100%', justifyContent: 'center', marginBottom: 40 }}>
      {!disGoBack && !isCheck && (
        <EAA_Btn text='返回' backgroundColor={leftColor} onClick={onClose} />
      )}

      {((mode === 'add') || (mode === 'edit')) && canSave && !isCheck && (
        <EAA_Btn text='儲存' backgroundColor={canSend ? '#80CAC8' : 'gray'} onClick={mode === 'add' ? onAdd : onSave} style={{ marginLeft: disGoBack ? 0 : 16 }} disabled={!canSend} />
      )}

      {!isCheck && (canReview || canBack) && (
        <EAA_Btn text='確認' backgroundColor={rightColor} onClick={goToCheck} style={{ marginLeft: 16 }} />
      )}

      {isCheck && (
        <EAA_Btn text='返回編輯' backgroundColor={leftColor} onClick={goToEdit} />
      )}
      {isCheck && canBack && (
        <EAA_Btn text='駁回' backgroundColor={canSend ? '#F2994A' : 'gray'} onClick={onBack} style={{ marginLeft: 16 }} disabled={!canSend} />
      )}
      {isCheck && canReview && (
        <EAA_Btn text={reviewText} backgroundColor={(allRight && canSend) ? rightColor : 'gray'} onClick={onReview} style={{ marginLeft: 16 }} disabled={!allRight || !canSend} />
      )}
    </div>
  );
};

export default EAA_BottomBtn;
